import { ClassRoomType } from "../../gql/graphql.ts";
import { TeacherClassRoomRecord } from "./teacherClassRoomRecord.ts";
import { shareOf } from "./shareOf.ts";

export type ClassRoomKind = "group" | "oneOnOne" | "progressCheck";

export type GroupClassFill = {
  averageStudents: number | null;
  averageSeats: number | null;
  fillRate: number | null;
};

export type Workload = {
  taughtClassRooms: number;
  taughtClassRoomsByKind: Record<ClassRoomKind, number>;
  distinctStudents: number;
  groupClassFill: GroupClassFill;
};

export function kindOf(classRoom: TeacherClassRoomRecord): ClassRoomKind {
  if (classRoom.type === ClassRoomType.Exam) return "progressCheck";
  return classRoom.is1on1 ? "oneOnOne" : "group";
}

function groupClassFillOf(
  groupClassRooms: TeacherClassRoomRecord[],
): GroupClassFill {
  const students = groupClassRooms.reduce(
    (total, classRoom) => total + classRoom.userIds.length,
    0,
  );
  const seats = groupClassRooms.reduce(
    (total, classRoom) => total + classRoom.capacity,
    0,
  );
  return {
    averageStudents: shareOf(students, groupClassRooms.length),
    averageSeats: shareOf(seats, groupClassRooms.length),
    fillRate: shareOf(students, seats),
  };
}

export function workloadOf(
  taughtClassRooms: TeacherClassRoomRecord[],
): Workload {
  const taughtClassRoomsByKind: Record<ClassRoomKind, number> = {
    group: 0,
    oneOnOne: 0,
    progressCheck: 0,
  };
  taughtClassRooms.forEach((classRoom) => {
    taughtClassRoomsByKind[kindOf(classRoom)] += 1;
  });
  const distinctStudents = new Set(
    taughtClassRooms.flatMap((classRoom) => classRoom.userIds),
  ).size;
  return {
    taughtClassRooms: taughtClassRooms.length,
    taughtClassRoomsByKind,
    distinctStudents,
    groupClassFill: groupClassFillOf(
      taughtClassRooms.filter((classRoom) => kindOf(classRoom) === "group"),
    ),
  };
}
